import { isInstitutionalActs, } from '@urbanik/api-contracts';
export class InstitutionalActWriteError extends Error {
    status;
    constructor(status) {
        super(status === 409
            ? 'El acta cambió. Cierra el formulario y actualiza antes de editar.'
            : status === 403
                ? 'No tienes permiso para guardar actas en esta entidad.'
                : 'No se pudo guardar el acta.');
        this.status = status;
    }
}
async function write(base, org, id, input, signal, lifecycle = false) {
    const valid = (id) => /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(id);
    if (!valid(org) || (id !== null && !valid(id)))
        throw new InstitutionalActWriteError(400);
    let response;
    try {
        response = await fetch(base.replace(/\/$/, '') +
            '/identity/multi-review/organizations/' +
            org +
            '/governance/acts' +
            (id ? '/' + id : '') +
            (lifecycle ? '/lifecycle' : ''), {
            method: id && !lifecycle ? 'PATCH' : 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', 'X-Urbanik-Review': '1' },
            body: JSON.stringify(input),
            signal: signal ?? null,
        });
    }
    catch (error) {
        if (signal?.aborted)
            throw error;
        throw new InstitutionalActWriteError(503);
    }
    if (!response.ok)
        throw new InstitutionalActWriteError(response.status);
    const data = await response.json().catch(() => {
        throw new InstitutionalActWriteError(502);
    });
    if (!isInstitutionalActs(data, org) ||
        data.items.length !== 1 ||
        (id !== null && data.items[0].id !== id))
        throw new InstitutionalActWriteError(502);
    return data.items[0];
}
export const setInstitutionalActDeleted = async (base, org, id, deleted, expectedVersion, reason, signal) => {
    const result = await write(base, org, id, { deleted, expectedVersion, reason }, signal, true);
    if (result.version !== expectedVersion + 1 || Boolean(result.deletedAt) !== deleted)
        throw new InstitutionalActWriteError(502);
    return result;
};
export const createInstitutionalAct = (base, org, input, signal) => write(base, org, null, input, signal);
export const updateInstitutionalAct = (base, org, id, input, signal) => write(base, org, id, input, signal);
